import { useState } from "react";
import { toast } from "sonner";
import { Eye } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const SupporterEmailPreview = ({ id }) => {
  const [html, setHtml] = useState(null);
  const open = async () => {
    try { const { data } = await api.post(`/recap/supporter-preview/${id}`); setHtml(data.html); }
    catch (e) { toast.error(errMsg(e, "Could not load preview")); }
  };
  return (
    <>
      <button className="text-sm text-mm-primary font-semibold mt-3 flex items-center gap-1" onClick={open} data-testid={`supporter-email-preview-${id}`}>
        <Eye size={14} /> Preview their weekly email
      </button>
      <Dialog open={!!html} onOpenChange={(o) => !o && setHtml(null)}>
        <DialogContent className="max-w-xl" data-testid="supporter-email-preview-dialog">
          <DialogHeader><DialogTitle>What your supporter will receive</DialogTitle></DialogHeader>
          <iframe title="Supporter email preview" sandbox="" srcDoc={html || ""} className="w-full h-[420px] rounded-xl border bg-white" />
        </DialogContent>
      </Dialog>
    </>
  );
};
